(function () {
  'use strict';

  angular.module('app').component('bookingItemDetailHotel', bookingItemDetailHotel());

  function bookingItemDetailHotel() {
    return {
      bindings: {
        productType: '<',
        bookingItem: '=',
        booking: '<',
        documentDateExchangeRate: '<',
        currencies: '<',
        companyBaseCurrencyId: '<',
        onBookingItemSaved: '&',
        onBookingItemCanceled: '&',
      },
      controller: BookingItemDetailCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/components/booking-item-detail-hotel/booking-item-detail-hotel.component.html',
    };
  }

  BookingItemDetailCtrl.$inject = [
    'CONFIGURATIONS',
    'moment',
    'HotelService',
    'AvailabilityService',
    'PriceListService',
  ];

  function BookingItemDetailCtrl(
    config,
    moment,
    HotelService,
    AvailabilityService,
    PriceListService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.productSelected = null;

    vm.inventory = null;

    // private properties
    // -----------------------
    // const dateDBDisplay = config.DATE_FORMAT_DB;

    vm.$onInit = function () {
      setDateOptions(); // Leave it here

      if (vm.bookingItem.id) {
        // view - edit
        vm.editMode = true;

        vm.bookingItem.start_date = moment(vm.bookingItem.start_date);
        vm.bookingItem.end_date = moment(vm.bookingItem.end_date);

        vm.checkOutDateOptions.minDate = angular.copy(vm.bookingItem.start_date).add(1, 'days');

        getHotel();
      } else {
        // new
        vm.showProductsSearch = true;

        vm.bookingItem.booking_type = vm.productType;
        vm.bookingItem.start_date = '';
        vm.bookingItem.end_date = '';

        if (vm.booking.price_list.related_price_list_id) {
          getBookingItemPriceList();
        } else {
          getDefaultPriceListForProviders();
        }
      }
    };

    // public methods
    // -----------------------
    vm.onHotelSelected = function (hotel) {
      vm.productSelected = hotel; // important

      vm.bookingItem.hotel_id = hotel.id;
      vm.bookingItem.provider_id = vm.editMode
        ? vm.bookingItem.provider_id
        : hotel.default_provider_id; // Edit / new

      if (vm.bookingItem.start_date && vm.bookingItem.end_date) {
        getHotelAvailability();
      }
    };

    vm.onHotelAddedToBookingItem = function (bookingItemObj) {
      let transactionTaxes = bookingItemObj.purchase_taxes.concat(bookingItemObj.sale_taxes);

      if (transactionTaxes.length > 0) {
        vm.bookingItem.transaction_taxes = transactionTaxes;
      }

      vm.onBookingItemSaved({ booking_item: vm.bookingItem });
    };

    vm.cancel = function () {
      vm.onBookingItemCanceled();
    };

    // private methods
    // -----------------------
    function getBookingItemPriceList() {
      PriceListService.getPriceList(vm.booking.price_list.related_price_list_id).then(function (
        data
      ) {
        vm.bookingItem.price_list = data;
        vm.bookingItem.price_list_id = data.id;
      });
    }

    function getDefaultPriceListForProviders() {
      let params = {
        get: 'active',
        contact_type: 'provider',
        skip_check_role: true,
      };

      PriceListService.getPriceLists(params).then((data) => {
        let defaultPriceListForProvider = data.items.find((priceList) => priceList.is_default);

        vm.bookingItem.price_list = defaultPriceListForProvider;
        vm.bookingItem.price_list_id = defaultPriceListForProvider.id;
      });
    }

    function setDateOptions() {
      vm.checkInDateOptions = {
        singleDatePicker: true,
        drops: 'up',
        // showDropdowns:    true,
        minDate: moment(),
        locale: {
          format: vm.dateDisplay,
        },
        eventHandlers: {
          'hide.daterangepicker': function () {
            // Clear invalid input
            if (vm.bookingItem.start_date && !vm.bookingItem.start_date._isValid) {
              vm.bookingItem.start_date = '';
              vm.checkInDateOptions.minDate = moment();
            }
          },
          'apply.daterangepicker': function () {
            vm.checkOutDateOptions.minDate = angular.copy(vm.bookingItem.start_date).add(1, 'days');

            if (vm.bookingItem.end_date && vm.bookingItem.end_date <= vm.bookingItem.start_date) {
              vm.bookingItem.end_date = ''; //vm.checkOutDateOptions.minDate;
            }

            setTimeout(() => {
              // hack
              document.querySelector('input[name="end_date"]').focus();
              // document.querySelector<HTMLElement>('input[name="end_date"]').click();
            }, 100);

            if (vm.bookingItem.start_date && vm.bookingItem.end_date) {
              getHotelAvailability();
            }
          },
        },
      };

      vm.checkOutDateOptions = {
        singleDatePicker: true,
        drops: 'up',
        // showDropdowns:    true,
        // minDate:          moment().add(1, 'days'),
        locale: {
          format: vm.dateDisplay,
        },
        eventHandlers: {
          'hide.daterangepicker': function () {
            // Clear invalid input
            if (vm.bookingItem.end_date && !vm.bookingItem.end_date._isValid) {
              vm.bookingItem.end_date = '';
              vm.checkOutDateOptions.minDate = moment();
            }
          },
          'apply.daterangepicker': function () {
            if (vm.bookingItem.start_date && vm.bookingItem.end_date) {
              getHotelAvailability();
            }
          },
        },
      };
    }

    function getHotelAvailability() {
      let params = {
        product_type: vm.bookingItem.booking_type,
        hotel_id: vm.productSelected.id,

        start_date: vm.bookingItem.start_date,
        end_date: vm.bookingItem.end_date,

        provider_id: vm.bookingItem.provider_id,
        booking_item_price_list_id: vm.bookingItem.price_list_id, // for provider

        client_id: vm.booking.client_id,
        price_list_id: vm.booking.price_list_id,
        company_id: vm.booking.company_id,

        skip_check_role: true,
      };

      vm.loadingAvailability = true;
      AvailabilityService.getAvailabilitySchedule(params).then((data) => {
        vm.inventory = data;

        // console.log(data);

        vm.loadingAvailability = false;
      });
    }

    function getHotel() {
      let params = {
        costs: false,
        taxes: true,
        skip_check_role: true,
      };

      vm.loadingHotel = true;
      HotelService.getHotel(vm.bookingItem.hotel_id, params).then(function (data) {
        vm.hotels = [data]; // hack - html

        setSelectBookingItemHotel(data);

        vm.loadingHotel = false;
      });
    }

    function setSelectBookingItemHotel(hotel) {
      vm.productSelected = hotel;

      getHotelAvailability();
    }
  }
})();
